import React, { useCallback, useEffect, useRef } from "react";
import { Box } from "@mantine/core";

const NO_SELECT_SX = {
	userSelect: "none",
	WebkitUserSelect: "none",
	MozUserSelect: "none",
	msUserSelect: "none",
	"& input, & textarea, & select, & [data-allow-knowledge-copy], & [contenteditable='true']": {
		userSelect: "text",
		WebkitUserSelect: "text",
	},
};

function isEditableTarget(target) {
	if (!target?.closest) return false;
	return !!target.closest(
		"input, textarea, select, button, a, [data-allow-knowledge-copy], [contenteditable='true']",
	);
}

export default function KnowledgeProtectedContent({ children, ...props }) {
	const ref = useRef(null);

	const blockClipboard = useCallback((event) => {
		if (!isEditableTarget(event.target)) {
			event.preventDefault();
		}
	}, []);

	const blockContextMenu = useCallback((event) => {
		if (!isEditableTarget(event.target)) {
			event.preventDefault();
		}
	}, []);

	useEffect(() => {
		const el = ref.current;
		if (!el) return undefined;

		const onSelectStart = (event) => {
			if (!isEditableTarget(event.target)) {
				event.preventDefault();
			}
		};

		const onKeyDown = (event) => {
			if (!isEditableTarget(event.target) && (event.ctrlKey || event.metaKey) && ["c", "x", "a"].includes(event.key.toLowerCase())) {
				event.preventDefault();
			}
		};

		el.addEventListener("selectstart", onSelectStart);
		el.addEventListener("keydown", onKeyDown);
		return () => {
			el.removeEventListener("selectstart", onSelectStart);
			el.removeEventListener("keydown", onKeyDown);
		};
	}, []);

	return (
		<Box
			ref={ref}
			{...props}
			sx={[NO_SELECT_SX, props.sx]}
			onCopy={blockClipboard}
			onCut={blockClipboard}
			onContextMenu={blockContextMenu}
			onDragStart={blockClipboard}
		>
			{children}
		</Box>
	);
}
